import * as React from 'react';

interface Props {
  title: string;
  base: string;
  toeOff: string;
  heelStrike: string;
}

export const StrideAnglesPanel: React.FC<Props> = ({
  title,
  base,
  toeOff,
  heelStrike,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="381.893"
      height="134.581"
      viewBox="0 0 381.893 134.581"
    >
      <g
        id="Group_2672"
        data-name="Group 2672"
        transform="translate(-311 -1714)"
      >
        <path
          id="Path_432"
          data-name="Path 432"
          d="M670.519,527.561"
          transform="translate(9.54 1296.933)"
          fill="none"
          stroke="#28666c"
          strokeWidth="1"
          opacity="0.5"
        />
        <line
          id="Line_17"
          data-name="Line 17"
          x2="13.065"
          y2="20.734"
          transform="translate(360.135 1756.265)"
          fill="none"
          stroke="#707070"
          strokeLinecap="round"
          strokeWidth="1"
          strokeDasharray="1 2"
        />
        <line
          id="Line_18"
          data-name="Line 18"
          x1="71.77"
          y2="46.252"
          transform="translate(567.778 1778.593)"
          fill="none"
          stroke="#707070"
          strokeLinecap="round"
          strokeWidth="1"
          strokeDasharray="1 2"
        />
        <path
          id="Path_419"
          data-name="Path 419"
          d="M71.846,38.613a4.428,4.428,0,0,0-3.9-3.169c-1.078-.123-2.314-.246-3.636-.377-5.258-.522-12.458-1.236-15.3-2.644-4.3-2.134-15.257-9.4-19.768-12.419a2.712,2.712,0,0,0-1.553-.451,12.248,12.248,0,0,1-.979-2.683c-1.488-6.048-.175-15.557-.161-15.651a1.066,1.066,0,0,0-2.11-.3c-.058.405-1.386,10.009.2,16.46a14.519,14.519,0,0,0,1.092,3.026,2.741,2.741,0,0,0-.77,1.723,6.355,6.355,0,0,0,.113,1.662,22.222,22.222,0,0,0,.719,2.731c-1.418.679-4.535,1.886-7.45,1.108A13.858,13.858,0,0,1,13.354,24.9a4.034,4.034,0,0,0-1.233-.673,9.426,9.426,0,0,0,.91-3.554c.182-2.949-.36-18.956-.384-19.634a1.027,1.027,0,0,0-1.1-1.028,1.066,1.066,0,0,0-1.03,1.1c.006.165.564,16.583.387,19.431a6.778,6.778,0,0,1-1.177,3.589A4.087,4.087,0,0,0,7.18,26.072a27.292,27.292,0,0,0-2.013,4.7A49.165,49.165,0,0,0,2.868,41l-.3.247c-.2.162-.8.652-2.5,5.387a1.067,1.067,0,0,0,.142.988c.139.19,3.5,4.674,12.016,5.419,3.893.34,12.029.43,19.559.43,8.127,0,15.547-.106,16.155-.114.545-.032,13.431-.843,19.933-6.173C71.147,44.5,72.635,41.292,71.846,38.613Zm-31.372-8.74L27.928,26.152a19.034,19.034,0,0,1-.76-2.781,4.228,4.228,0,0,1-.075-1.1.626.626,0,0,1,.353-.534.593.593,0,0,1,.613.043C30.8,23.61,35.89,26.993,40.474,29.874ZM7.19,31.445a25.243,25.243,0,0,1,1.851-4.333,1.974,1.974,0,0,1,1.367-.978,1.925,1.925,0,0,1,1.587.4,15.527,15.527,0,0,0,5.8,3.152c4.036,1.085,8.155-.822,9.459-1.513L48.18,34.383c3.241,1.545,10.263,2.244,15.922,2.806,1.31.13,2.536.25,3.6.372a2.328,2.328,0,0,1,2.1,1.655,3.017,3.017,0,0,1,.1.83c-2.576.926-12.469,4.371-19.595,5.29a73.67,73.67,0,0,1-20.167-.306,73.124,73.124,0,0,0-7.9-.512c-2.408-.065-5.136-.139-8.733-.489C8.07,43.5,5.716,41.805,5,41.154A47.92,47.92,0,0,1,7.19,31.445ZM66.516,45.536c-5.964,4.89-18.58,5.686-18.661,5.69-.273,0-27.461.388-35.449-.309-6.038-.528-9.135-3.141-10.122-4.151a38.063,38.063,0,0,1,1.572-3.773C5.084,44,7.837,45.618,13.3,46.151c3.671.358,6.44.433,8.882.5a70.657,70.657,0,0,1,7.683.5,89.362,89.362,0,0,0,11.8.887,69.289,69.289,0,0,0,8.91-.581c6.4-.826,14.685-3.525,18.552-4.87A10.979,10.979,0,0,1,66.516,45.536Z"
          transform="matrix(0.839, -0.545, 0.545, 0.839, 534.142, 1783.972)"
          fill="#707070"
        />
        <path
          id="Path_420"
          data-name="Path 420"
          d="M71.846,38.613a4.428,4.428,0,0,0-3.9-3.169c-1.078-.123-2.314-.246-3.636-.377-5.258-.522-12.458-1.236-15.3-2.644-4.3-2.134-15.257-9.4-19.768-12.419a2.712,2.712,0,0,0-1.553-.451,12.248,12.248,0,0,1-.979-2.683c-1.488-6.048-.175-15.557-.161-15.651a1.066,1.066,0,0,0-2.11-.3c-.058.405-1.386,10.009.2,16.46a14.518,14.518,0,0,0,1.092,3.026,2.741,2.741,0,0,0-.77,1.723,6.355,6.355,0,0,0,.113,1.662,22.221,22.221,0,0,0,.719,2.731c-1.418.679-4.535,1.886-7.45,1.108A13.858,13.858,0,0,1,13.354,24.9a4.034,4.034,0,0,0-1.233-.673,9.426,9.426,0,0,0,.91-3.554c.182-2.949-.36-18.956-.384-19.634a1.027,1.027,0,0,0-1.1-1.028,1.066,1.066,0,0,0-1.03,1.1c.006.165.564,16.583.387,19.431a6.778,6.778,0,0,1-1.177,3.589A4.087,4.087,0,0,0,7.18,26.072a27.292,27.292,0,0,0-2.013,4.7A49.165,49.165,0,0,0,2.868,41l-.3.247c-.2.162-.8.652-2.5,5.387a1.067,1.067,0,0,0,.142.988c.139.19,3.5,4.674,12.016,5.419,3.893.34,12.029.43,19.559.43,8.127,0,15.547-.106,16.155-.114.545-.032,13.431-.843,19.933-6.173C71.147,44.5,72.635,41.292,71.846,38.613Zm-31.372-8.74L27.928,26.152a19.034,19.034,0,0,1-.76-2.781,4.227,4.227,0,0,1-.075-1.1.626.626,0,0,1,.353-.534.593.593,0,0,1,.613.043C30.8,23.61,35.89,26.993,40.474,29.874ZM7.19,31.445a25.243,25.243,0,0,1,1.851-4.333,1.974,1.974,0,0,1,1.367-.978,1.925,1.925,0,0,1,1.587.4,15.527,15.527,0,0,0,5.8,3.152c4.036,1.085,8.155-.822,9.459-1.513L48.18,34.383c3.241,1.545,10.263,2.244,15.922,2.806,1.31.13,2.536.25,3.6.372a2.328,2.328,0,0,1,2.1,1.655,3.017,3.017,0,0,1,.1.83c-2.576.926-12.469,4.371-19.595,5.29a73.67,73.67,0,0,1-20.167-.306,73.124,73.124,0,0,0-7.9-.512c-2.408-.065-5.136-.139-8.733-.489C8.07,43.5,5.716,41.805,5,41.154A47.92,47.92,0,0,1,7.19,31.445ZM66.516,45.536c-5.964,4.89-18.58,5.686-18.661,5.69-.273,0-27.461.388-35.449-.309-6.038-.528-9.135-3.141-10.122-4.151a38.063,38.063,0,0,1,1.572-3.773C5.084,44,7.837,45.618,13.3,46.151c3.671.358,6.44.433,8.882.5a70.657,70.657,0,0,1,7.683.5,89.362,89.362,0,0,0,11.8.887,69.289,69.289,0,0,0,8.91-.581c6.4-.826,14.685-3.525,18.552-4.87A10.979,10.979,0,0,1,66.516,45.536Z"
          transform="translate(411.902 1741.955) rotate(56)"
          fill="#707070"
        />
        <line
          id="Line_15"
          data-name="Line 15"
          x2="374.8"
          transform="translate(311 1824.845)"
          fill="none"
          stroke="#707070"
          strokeWidth="1"
        />
        <rect
          id="Rectangle_61"
          data-name="Rectangle 61"
          width="183.926"
          height="19.301"
          rx="9.65"
          transform="translate(406.504 1714)"
          fill="#707070"
        />
        <text
          id="Left_foot"
          data-name="Left foot"
          transform="translate(492.835 1715.135)"
          fill="#fff"
          fontSize="12"
          fontFamily="Montserrat-Bold, Montserrat"
          fontWeight="700"
        >
          <tspan x="-26.766" y="12">
            {title}
          </tspan>
        </text>
        <text
          id="_78.2_"
          data-name="78.2º"
          transform="translate(311.797 1780.834)"
          fill="#28666c"
          fontSize="19"
          fontFamily="Montserrat-Bold, Montserrat"
          fontWeight="700"
        >
          <tspan x="0" y="0">
            {toeOff}
          </tspan>
        </text>
        <text
          id="_25.4_"
          data-name="25.4º"
          transform="translate(643.893 1803.834)"
          fill="#28666c"
          fontSize="19"
          fontFamily="Montserrat-Bold, Montserrat"
          fontWeight="700"
        >
          <tspan x="0" y="0">
            {heelStrike}
          </tspan>
        </text>
        <text
          id="_1.1_m"
          data-name="1.1 m"
          transform="translate(475.9 1843.581)"
          fill="#28666c"
          fontSize="19"
          fontFamily="Montserrat-Bold, Montserrat"
          fontWeight="700"
        >
          <tspan x="0" y="0">
            {base}
          </tspan>
        </text>
        <path
          id="Polygon_6"
          data-name="Polygon 6"
          d="M5.511,1.519a1,1,0,0,1,1.736,0L11.9,9.668a1,1,0,0,1-.868,1.5H1.723a1,1,0,0,1-.868-1.5Z"
          transform="translate(620.689 1790.273) rotate(-26)"
          fill="#28666c"
        />
        <path
          id="Polygon_7"
          data-name="Polygon 7"
          d="M5.511,1.519a1,1,0,0,1,1.736,0L11.9,9.668a1,1,0,0,1-.868,1.5H1.723a1,1,0,0,1-.868-1.5Z"
          transform="translate(643.893 1824.02) rotate(175)"
          fill="#28666c"
        />
        <path
          id="Path_425"
          data-name="Path 425"
          d="M75.982,20.958a68.465,68.465,0,0,1,9.393,31.9"
          transform="translate(551.677 1769.46)"
          fill="none"
          stroke="#28666c"
          strokeWidth="1"
        />
        <path
          id="Polygon_2"
          data-name="Polygon 2"
          d="M5.511,1.519a1,1,0,0,1,1.736,0L11.9,9.668a1,1,0,0,1-.868,1.5H1.723a1,1,0,0,1-.868-1.5Z"
          transform="translate(371.115 1775.348) rotate(47)"
          fill="#28666c"
        />
        <path
          id="Polygon_3"
          data-name="Polygon 3"
          d="M5.511,1.519a1,1,0,0,1,1.736,0L11.9,9.668a1,1,0,0,1-.868,1.5H1.723a1,1,0,0,1-.868-1.5Z"
          transform="translate(357.276 1825.581) rotate(-173)"
          fill="#28666c"
        />
        <path
          id="Path_426"
          data-name="Path 426"
          d="M30.362,29.759C17.073,25.121,5.875,14.39,0,0"
          transform="matrix(0.259, 0.966, -0.966, 0.259, 372.811, 1783.162)"
          fill="none"
          stroke="#28666c"
          strokeWidth="1"
        />
        <path
          id="Path_2408"
          data-name="Path 2408"
          d="M60,462.8H210.606"
          transform="translate(353.971 1362.041)"
          fill="none"
          stroke="#28666c"
          strokeLinecap="round"
          strokeWidth="3"
        />
      </g>
    </svg>
  );
};
